import { PnlAtacado } from "./PnlAtacado";

/**
 * #58: o toggle "Atacado | Varejo" foi removido — as tags do card
 * (Total·vivo / Atacado·em breve / Varejo·em breve) são o seletor de book.
 * O split por book volta com o #60; PnlVarejo segue no repo pra essa fase.
 */
export function PnlTab() {
  return <PnlAtacado />;
}
